import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/auth/Login.vue'
import Companies from '../views/companies/Companies.vue'
import Employees from '../views/employees/Employees.vue'
import Schools from '../views/schools/Schools.vue'
import SchoolDetail from '../views/schools/SchoolDetail.vue'
import Teachers from '../views/teachers/Teachers.vue'
import Tasks from '../views/tasks.vue'
import JobImport from '../views/JobImport.vue'
import TasksDetail from '../views/TaskDetail.vue'
import NewsForm from '../views/teachers/NewsForm.vue'
import NewsDetail from '../views/teachers/NewsDetail.vue'
import ConfirmMembers from '../views/confirm_members/ConfirmMembers.vue'
import Notices from '../views/Notices.vue'

const TheContainer = () => import('@/containers/TheContainer')

Vue.use(VueRouter)

const requireAuth = (to, from, next) => {
  const user = localStorage.getItem('is_auth')
  if (user == 'false') {
    next({ name: 'Login' })
  } else {
    next()
  }
}

const requireNoAuth = (to, from, next) => {
  const user = localStorage.getItem('is_auth')
  if (user == 'true') {
    next({ name: 'Dashboard' })
  } else {
    next()
  }
}

const isPermitted = (to, from, next) => {
  const role = localStorage.getItem('role')
  if(role == 'super_admin') {
    next()
  } else {
    return false
  }
}

const isMemberNotPermitted = (to, from, next) => {
  const role = localStorage.getItem('role')
  if(role == 'member') {
    return false
  } else {
    next()
  }
}

const routes = [
  {
    path: '/',
    redirect: '/dashboard',
    name: 'Home',
    component: TheContainer,
    beforeEnter: requireAuth,
    children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Schools
        },
        {
          path: 'teachers',
          name: 'Teachers',
          component: Teachers,
          beforeEnter: isMemberNotPermitted,
        },
        {
          path: 'news/form',
          name: 'news',
          component: NewsForm
        },
        {
          path: 'news/:id/form',
          name: 'news',
          component: NewsForm
        },
        {
          path: 'news/:id',
          name: 'news',
          component: NewsDetail
        },
        {
          path: 'tasks',
          name: 'tasks',
          component: Tasks,
          meta: { label: 'インポート管理', breadcrumb: 'インポート管理' },
          children: [
            {
              path: 'import',
              name: 'JobImport',
              component: JobImport,
              meta: { label: '法人向け求人アップロード', breadcrumb: '法人向け求人アップロード' },
            }
          ]
        },
        {
          path: 'tasks/:id',
          name: 'taskdetail',
          component: TasksDetail
        },
        {
          path: 'schools',
          name: 'schools',
          component: Schools
        },
        {
          path: 'companies',
          name: 'companies',
          component: Companies
        },
        {
          path: 'employees',
          name: 'employees',
          component: Employees
        },
        {
          path: 'schools/:id',
          name: 'SchoolDetail',
          component: SchoolDetail
        },
        {
          path: 'confirm_members',
          name: 'Confirm Members',
          component: ConfirmMembers,
          beforeEnter: isPermitted,
        },
        {
          path: 'notices',
          name: 'Notices',
          component: Notices
        },
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    beforeEnter: requireNoAuth,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
